import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import usePortalAuth from '../../../auth/usePortalAuth';
import LoginRedirect from '../../Login/LoginRedirect';

const AccountAdminRoute = ({ component: Component, path, location, accessLevel, ...rest }) => {
  const { isLoading, isAuthenticated } = usePortalAuth();


  const checkAccessLevel = (accessLevel) => {
    if (accessLevel === 'AccountAdmin') {
      return true;
    } else {
      return false;
    }
  };

  const render = (props) => {
    if (isLoading) {
      return null;
    }
    if (isAuthenticated !== true) {
      return <LoginRedirect history={props.history} />;
    }

    if (!checkAccessLevel(accessLevel)) {
      return <Redirect to="/Dashboard/History" />;
    }

    return <Component {...props} />;
  };

  return (
    <Route
      path={path}
      render={(props) => render(props)}
      {...rest}
    />
  );
};

export default AccountAdminRoute;
